<template>
  <div>
    <div class="title">{{ year }}年{{ yxmc }}毕业生信息</div>
    <div>
      <el-row>
        <!-- 一行中有两个大小相同的列 -->
        <el-col :span="12" class="col1">
          <div id="myChart3" :style="{ width: '100%', height: '100%' }"></div>
        </el-col>
        <el-col :span="12" class="col2">
          <div id="myChart4" :style="{ width: '100%', height: '100%' }"></div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>


<script>
import school from "../../api/forecast";
export default {
  data() {
    return {
      data: [],
      idbk: 18,
      yxmc: "湖北大学",
      year: 2020,
      bboys: 100,
      bgirls: 100,
      bsx: 0,
      bwjy: 0,
      blhjy: 0,
      bcy: 0,
      bxyhhtjy: 0,
      //图一
      option3: {
        title: {
          text: "毕业生男女比例",
          // subtext: "Fake Data",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
        },
        series: [
          {
            name: "北京大学",
            type: "pie",
            radius: "50%",
            data: [
              { value: 34, name: "男生人数", itemStyle: { color: "#00a8e1" } },
              { value: 66, name: "女生人数", itemStyle: { color: "#e30039" } },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      },

      //图二

      option4: {
        title: {
          text: "毕业生就业去向",
          // subtext: "Fake Data",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
        },
        series: [
          {
            name: "北京大学",
            type: "pie",
            radius: "50%",
            data: [
              { value: 1048, name: "升学", itemStyle: { color: "#00a8e1 " } },
              { value: 735, name: "未就业", itemStyle: { color: "#99cc00  " } },
              {
                value: 580,
                name: "灵活就业",
                itemStyle: { color: "#e30039  " },
              },
              { value: 484, name: "创业", itemStyle: { color: "#fcd300  " } },
              {
                value: 300,
                name: "协议合同就业",
                itemStyle: { color: "#ff6600  " },
              },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      },
    };
  },
  props: ["idbk"],
  watch: {
    option3: {
      handler(newName, oldName) {
        if (newName) {
          this.drawGender2();
        }
      },
      deep: true,
    },

    option4: {
      handler(newName, oldName) {
        if (newName) {
          this.drawEmployment2();
        }
      },
      deep: true,
    },
    idbk: {
      handler(newValue, oldValue) {
        if (newValue) {
          this._data.idbk = this._props.idbk;
          this.getJyxxSchoolById();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getJyxxSchoolById();
    this.drawGender2();
    this.drawEmployment2();
  },
  created() {
    this.idbk = this._props.idbk;
  },
  methods: {
    getJyxxSchoolById() {
      school.getJyxxSchoolById(this.idbk).then((res) => {
        // console.log(res);
        this.data = res.data;
        this.yxmc = this.data.yxmc;
        this.year = this.data.year;
        this.option3.series[0].name = this.data.yxmc;
        this.option3.series[0].data[0].value = this.data.bboys;
        this.option3.series[0].data[1].value = this.data.bgirls;
        this.option4.series[0].name = this.data.yxmc;
        this.option4.series[0].data[0].value = this.data.bsx;
        this.option4.series[0].data[1].value = this.data.bwjy;
        this.option4.series[0].data[2].value = this.data.blhjy;
        this.option4.series[0].data[3].value = this.data.bcy;
        this.option4.series[0].data[4].value = this.data.bxyhhtjy;
      });
    },

    //毕业生男女人数环形图
    drawGender2() {
      // 基于准备好的dom，初始化echarts实例
      let myChart3 = this.$echarts.init(document.getElementById("myChart3"));
      //准备数据
      // 绘制图表
      myChart3.setOption(this.option3);
    },
    //毕业生就业去向环形图
    drawEmployment2() {
      // 基于准备好的dom，初始化echarts实例
      let myChart4 = this.$echarts.init(document.getElementById("myChart4"));
      //准备数据

      // 绘制图表
      myChart4.setOption(this.option4);
    },
  },
};
</script>

<style scoped>
.title {
  line-height: 60px;
  font-weight: 400;
  font-size: 30px;
  padding: 20px 0;
  padding-top: 0;
  text-align: center;
}
.el-col {
  height: 500px;
}
</style>
